import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import styles from './homework.module.scss';
import './darkModeHomework.css';
import { homeworkQuestionsWithAnswers } from '../../../../http/homeworkAPI';
import Header from '../../../../components/Headers/Header';
import ChatApp from '../../../../components/ChatApp/ChatApp';
import { homeworkAnswerPost } from '../../../../http/homeworkAPI';
import { isNumber } from 'lodash';
import { wordNumDeclention } from '../../../TeacherCabinet/utils';
import LoadingSpinner from '../../../../components/LoadingSpinner/LoadingSpinner';

import finishMobile from './finishHWmob.png'
import finishDesktop from './finishHW.png'
import { HtmlContentRenderer } from "../../../../helpers";

const Homework = () => {
  const [homework, setHomework] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedOption, setSelectedOption] = useState(0);
  const [file, setFile] = useState({});
  const [totalScore, setTotalScore] = useState(0);
  const [userAnswers, setUserAnswers] = useState({});
  const [errorMessage, setErrorMessage] = useState(null);

  const [finishPage, setFinishPage] = useState(false)

  const location = useLocation();
  const homeworkId = location.state.homeworkId;

  const homeWorkQuestionsCount = homework.length

  const userAnswersCount = homework.filter(question => Boolean(question?.user_answer_id)).length

  const showCorrectAnswer = userAnswersCount === homeWorkQuestionsCount

  useEffect(() => {
    const fetchingHomework = async () => {
      try {
        const data = await homeworkQuestionsWithAnswers(homeworkId);
        setHomework(data.body);
      } catch (error) {
        console.error('Homework unavailible', error);
      } finally {
        setLoading(false);
      }
    };
    fetchingHomework();
  }, [homeworkId]);

  useEffect(() => {
    if (errorMessage) {
      const timer = setTimeout(() => {
        setErrorMessage('');
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [errorMessage]);

  useEffect(() => {
    if (!homework) return;
    const total = homework.reduce((prev, next) => {
      if (next.answer_points) {
        prev += next.answer_points
      }
      return prev
    }, 0)
    setTotalScore(total)

  }, [homework, currentIndex]);

  if (loading) {
    return <LoadingSpinner />; {/* Заменяем стандартную загрузку на кастомную */ }

  }

  const handelPagination = (index) => {
    setCurrentIndex(index);
    setSelectedOption(null);
  };

  const handleFinish = () => {
    setFinishPage(true);
  };

  const handleCheck = async () => {
    const questionId = homework[currentIndex].question_id;
    const formData = new FormData();

    if (homework[currentIndex].type === 'multiple_choice') {
      formData.append('answer', String(selectedOption));
    } else if (homework[currentIndex].type === 'text' || homework[currentIndex].type === 'test') {
      formData.append('answer', userAnswers[currentIndex]);
    }


    if (file[currentIndex]) {
      formData.append('file', file[currentIndex]);
    }

    try {
      const result = await homeworkAnswerPost(questionId, formData);
      setHomework((prevHomework) =>
        prevHomework.map((question, index) =>
          index === currentIndex
            ? { ...question, user_answer: result.body.answer, answer_points: result.body.points }
            : question,
        ),
      );
    } catch (error) {
      console.error('Mistake from server', error);
      if (error.response && error.response.status === 400) {
        setErrorMessage(
          error.response.data.message || 'Вы уже ответили на этот вопрос',
        );
      }
    }
  };

  const isQuestionAnswered = (question) => 'user_answer' in question;


  const handleFileChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      const fileUploading = event.target.files[0];
      setFile((prevFiles) => ({
        ...prevFiles,
        [currentIndex]: fileUploading,
      }));
      console.log(`Файл для задания ${currentIndex + 1}:`, fileUploading.name);
    } else {
      console.log('Файл не выбран');
    }
  };

  const removeFile = () => {
    setFile((prevFiles) => {
      const updatedFiles = { ...prevFiles };
      delete updatedFiles[currentIndex];
      return updatedFiles;
    });
  };

  const handleUserAnswer = (event) => {
    setUserAnswers((prevAnswers) => ({
      ...prevAnswers,
      [currentIndex]: event.target.value,
    }));
  };

  const handleOptionSelect = (index) => {
    setSelectedOption(index);
  };

  const getAnswerClass = (params, current) => {
    if (isNumber(params.user_answer)) {
      if (current === +params.correct_answer) {
        return styles.correctAnswer
      }
      if (current === params.user_answer) {
        return params.is_correct ? styles.correctAnswer : styles.wrongAnswer
      }
      return `${styles.checkbox} homeworkCheckbox`
    }
    return current === selectedOption
      ? `${styles.checkboxActive} homeworkCheckboxActive`
      : `${styles.checkbox} homeworkCheckbox`
  }

  const handleShowResult = () => {
    setFinishPage(false);
    setCurrentIndex(0)
  }

  return (
    <div className='min-h-screen flex flex-col'>
      <div className={styles.homework}>
        <Header />
        {homework.length > 0 ? (
          <div className={styles.homeworkContainer}>
            {/* <div className={styles.homeworkTitle}>
              <h2>{themeTitle}</h2>
            </div> */}
            <div className='px-6 flex flex-col gap-2 mt-4'>
              <div className={styles.paginationInform}>
                <p className="homeworkPaginationInform">
                  Вы набрали уже {totalScore} {wordNumDeclention(totalScore, 'points')}
                </p>
              </div>

              <div className={`${styles.pagination} homeworkPagination`}>
                <ul>
                  {homework.map((item, index) => (
                    <li
                      key={index}
                      onClick={() => handelPagination(index)}
                      className={
                        currentIndex === index
                          ? `${styles.currentPag}`
                          : `${styles.pag} homeworkPag`
                      }
                    >
                      {index + 1}
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {finishPage ? <div className='grow relative'>
              <div className='absolute h-full w-auto flex flex-col items-center'>
                <img src={finishMobile} alt="" className='sm:hidden translate-y-12' />
                <img src={finishDesktop} alt="" className='hidden sm:block max-w-[70%] mx-auto' />
                <button
                  className='relative mt-4 sm:mt-[-4rem] bg-lavender text-white rounded-2xl px-3 py-4 font-medium'
                  onClick={handleShowResult}
                >
                  Посмотреть результат
                </button>
              </div>


            </div> : <div className={styles.homeworkTask}>
              {homework[currentIndex] && (
                <>
                  <div className={`${styles.taskTitle} homeworkTaskTitle`}>
                    <div className={styles.taskMainTitle}>
                      <h3 className="homeworkMainTitle">
                        Задание №{currentIndex + 1}
                      </h3>
                    </div>

                    {homework[currentIndex].type === 'multiple_choice' && <div className={styles.taskPoints}>
                      <p className="taskPointText">
                        Макс. балл
                        <span className="taskPoint">
                          {homework[currentIndex].points}
                        </span>
                      </p>
                    </div>}
                  </div>

                  <div className={styles.taskInform}>
                    {homework[currentIndex].title ? (
                      <HtmlContentRenderer
                        htmlContent={homework[currentIndex]?.title ?? ''}
                        photo_url={homework[currentIndex]?.quest_photo_url ?? ''}
                        disabledImages={false}
                      />
                    ) : (
                      <p className="taskInformTitle">Выбери правильный ответ</p>
                    )}
                  </div>

                  <div className={styles.taskChoose}>
                    {homework[currentIndex].type === 'multiple_choice' ? (
                      <ul className={`${styles.chooseList} ${isNumber(homework[currentIndex].user_answer) ? styles.answered : ''}`}>
                        {Array.isArray(homework[currentIndex].options) &&
                          homework[currentIndex].options.length > 0 ? (
                          homework[currentIndex].options.map((item, index) => (
                            <li key={index} >
                              <div
                                className={
                                  getAnswerClass(homework[currentIndex], index)
                                }
                                onClick={() => handleOptionSelect(index)}
                              />
                              <p
                                className={styles.chooseText}
                              >
                                {item}
                              </p>
                            </li>
                          ))
                        ) : (
                          <p>Готовим вопросы! А ты пока попробуй догадаться.</p>
                        )}
                      </ul>
                    ) : (

                      <div className={styles.typeText}>
                        {/* Показываем кнопку загрузки файла только если тип не test */}
                        {homework[currentIndex].type !== 'test' && (
                          <div className={styles.uploadFile}>
                            {file[currentIndex] ? (
                              <div className={styles.fileUploaded}>
                                <p>{file[currentIndex].name}</p>
                                <button onClick={removeFile}>❌</button>
                              </div>
                            ) : (
                              <div className={styles.fileUploading}>
                                <button>
                                  <input
                                    type="file"
                                    style={{ opacity: '0' }}
                                    onChange={handleFileChange}
                                  />
                                  Загрузить файл
                                </button>
                              </div>
                            )}
                          </div>
                        )}

                        {/* Поле ввода текста */}
                        <div className={`${styles.typeTextInput} homeworkTypeTextInput`}>
                          <textarea
                            type="text"
                            className="textInput"
                            placeholder="Введите ответ на задание"
                            value={homework[currentIndex]?.user_answer || userAnswers[currentIndex] || ''}
                            onChange={handleUserAnswer}
                          />
                          {errorMessage && <p className={styles.errorMessage}>{errorMessage}</p>}
                        </div>
                      </div>

                    )}
                  </div>

                  <div className={styles.taskButton}>
                    {isQuestionAnswered(homework[currentIndex]) ? (
                      <div className='bg-lavender text-white rounded-2xl px-3 py-4 font-medium'>{homework[currentIndex].answer_points} {wordNumDeclention(homework[currentIndex].answer_points, 'points')}</div>
                    ) : (
                      <button
                        onClick={handleCheck}
                        className={styles.btnSubmit}
                      >
                        Проверить
                      </button>
                    )}

                    <button
                      className={styles.btnSubmit}
                      onClick={() =>
                        currentIndex === homework.length - 1
                          ? handleFinish()
                          : handelPagination(currentIndex + 1)
                      }
                    >
                      {currentIndex === homework.length - 1
                        ? 'Завершить'
                        : 'Продолжить'}
                    </button>
                  </div>

                  {isQuestionAnswered(homework[currentIndex]) && (
                    <div>
                      {/* Показываем correct_answer_text только для text */}
                      {homework[currentIndex].type === 'text' && homework[currentIndex].correct_answer_text && (
                        <div>
                          <div className="flex items-center gap-4 px-4 mt-16">
                            <div className='w-[46px] h-[46px] relative'>
                              <img className="" src="/images/chat/boost.png" alt='Boost' />
                            </div>
                            <div className="chat-info">
                              <strong>Ответ от робота Boost</strong>
                            </div>
                          </div>
                          <div className='mt-4 leading-6 text-lavender bg-lavender-8 py-4 px-6 text-[18px] font-semibold rounded-2xl'>
                            {homework[currentIndex].correct_answer_text}
                          </div>
                        </div>
                      )}

                      {/* Показываем teacher_comment только для test/text и только если комментарий есть */}
                      {(homework[currentIndex].type === 'test' || homework[currentIndex].type === 'text') && homework[currentIndex].teacher_comment && (
                        <div>
                          <div className="flex items-center gap-4 px-4 mt-16">
                            <div className='w-[46px] h-[46px] relative'>
                              <img className="" src="/images/chat/expert.png" alt='Boost' />
                            </div>
                            <div className="chat-info">
                              <strong>Комментарий преподавателя</strong>
                            </div>
                          </div>
                          <div className='mt-4 leading-6 text-lavender bg-lavender-8 py-4 px-6 text-[18px] font-semibold rounded-2xl'>
                            <HtmlContentRenderer
                              htmlContent={homework[currentIndex]?.teacher_comment ?? ''}
                              photo_url={homework[currentIndex]?.quest_photo_url ?? ''}
                              disabledImages={false}
                            />
                          </div>
                        </div>
                      )}


                      {/* Показываем correct_answer только если пользователь ответил */}
                      {/* {homework[currentIndex].correct_answer && homework[currentIndex].type === 'text' && (
                        <div>
                          <div className="flex items-center gap-4 px-4 mt-16">
                            <div className='w-[46px] h-[46px] relative'>
                              <img className="" src="/images/chat/expert.png" alt='Expert' />
                            </div>
                            <div className="chat-info">
                              <strong>Ответ от преподавателя курса</strong>
                            </div>
                          </div>
                          <div className='mt-4 leading-6 text-lavender bg-lavender-8 py-4 px-6 text-[18px] font-semibold rounded-2xl'>
                            {homework[currentIndex].correct_answer}
                          </div>
                        </div>
                      )} */}
                    </div>
                  )}

                </>
              )}
            </div>}
          </div>
        ) : (
          <div>
            <p className={styles.noThemesMessage}>
              Домашние задания отсутствуют.
            </p>
          </div>
        )}
        <ChatApp />
      </div>
    </div >
  );
};

export default Homework;